<div mat-dialog-actions fxLayout="row" fxLayoutGap="10px">
	<span fxFlex></span>
	<button *ngIf="!asClose && !cancelOnly" mat-button color="primary" [disabled]="disabled" (click)="close()">{{ okCaption }}</button>
	<button mat-button (click)="cancel()">{{ cancelCaption }}</button>
</div>
